<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center">Maestro de Proveedores</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
            hide-details></v-text-field>
          <v-data-table :headers="headers" :items="datos" :items-per-page="15" class="elevation-1 custom-font"
            :search="search">
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
              <!-- <v-icon small @click="showQR(item)">mdi-qrcode</v-icon> -->
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="editedItem.dni" label="RUT/DNI" required outlined></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field v-model="editedItem.name" label="Nombre" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.address" label="Direccion" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.contact" label="Email de contacto" required outlined></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="wqr" persistent width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ qr.nombre }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <span class="d-flex justify-center">
            <vue-qrcode :value="qr.nombre + '-' + qr.time + '@' + qr.id" :margin="1" :scale="12" />
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="generatePrintQr">Descargar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="wqr = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import api from "../conf/ruta-base"
import store from "../store"
import router from '../router'
import XLSX from 'xlsx'
import VueQrcode from 'vue-qrcode'
import VueHtml2pdf from 'vue-html2pdf'
import UserProfile from '../data';
import { formatRut, validateRut, cleanRut } from 'rutlib';
import validateEmail from '../tools/validateEmail';

moment.locale('es')
export default {
  name: "usuarios",
  components: {
    VueQrcode, VueHtml2pdf
  },
  data: () => ({
    apiPath: "suppliers", search: "", dialog: false, date: new Date().toISOString().substr(0, 10), wqr: false, api: api.api, qr: [],
    headers: [
      { text: "RUT", value: "dni" },
      { text: "Nombre", align: "start", sortable: true, value: "name" },
      { text: "Direccion", value: "address" },
      { text: "Contacto", value: "contact" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    datos: [], user: UserProfile.getUserData(),
    selec: '', viewData: 'inline',
    instituciones: [], dialogofType: '', personSimple: [], editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),
  mounted() {
    axios
      .get(`${api.api}/${this.apiPath}`)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          r.data[i].dni = formatRut(r.data[i].dni);
          this.datos.push(r.data[i])
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Proveedor" : "Modificar Proveedor";
    }
  },
  watch: {
    'editedItem.dni': function (newVal, oldVal) {
      this.editedItem.dni = formatRut(newVal);
    },
    wqr(value) {
      if (value) {
        this.viewData = 'none'
      } else {
        this.viewData = 'inline'
      }
    }
  },
  methods: {

    fechas(evento) {
      this.dialogofType = evento;
      this.calendario = true;
    },

    fechasave(evento) {
      let [year, month, day] = this.date.split('-')
      let date = day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year
      if (evento == 'ingreso') {
        this.editedItem.fecingreso = date
        this.editedItem.fecha_ingreso = this.date
      } else if (evento == 'nacimiento') {
        this.editedItem.fecnacimiento = date
        this.editedItem.fecha_nacimiento = this.date
      }
      this.dialogofType = ''
      this.calendario = false
      this.date = new Date().toISOString().substr(0, 10)
    },

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave() {
      let bandera = true
      let err = ''
      if (!validateRut(this.editedItem.dni)) {
        swal('', "Favor verifique el Rut/Dni", 'error');
        return
      }
      if (!validarEmail(this.editedItem.contact)) {
        swal('', "Favor verifique email", 'error');
        return
      }
      if (bandera && (this.editedItem.name.length == 0 || this.editedItem.address.length == 0 || this.editedItem.contact.length == 0)) {
        bandera = false
        err = 'validar los datos.'
      }

      if (bandera) {
        this.save()
      } else {
        swal('', err, 'error');
      }

    },

    save() {
      const item = { ...this.editedItem }
      item.dni = cleanRut(item.dni);
      if (this.editedIndex > -1) {
        let index = this.editedIndex
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        axios
          .patch(api.api + "/" + this.apiPath + '/' + item.id, item)
          .then(res => {
            this.toast("success", "Actualizado correctamente")
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axios
          .post(api.api + "/" + this.apiPath, item)
          .then(res => {
            res.data.dni = formatRut(res.data.dni)
            this.datos.push(res.data)
            this.toast("success", "Agregado correctamente")

          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },

    showQR(item) {
      this.qr = item
      this.qr.time = Date.now();
      this.wqr = true
    },

    deleteItem(item) {
      const index = this.datos.indexOf(item)
      swal({ text: "¿Seguro que desea eliminar?", icon: "warning", buttons: ["Cancelar", "Ok"], })
        .then(ok => {
          if (ok) {
            axios.delete(api.api + '/' + this.apiPath + '/' + item.id)
              .then(res => {

                this.datos.splice(index, 1)

                this.toast("success", "Eliminado correctamente")
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
    },

    restablecer() {
      axios
        .put(api.api + this.apiPath + '/reset/' + this.editedItem.id, this.editedItem)
        .then(res => {
          this.toast(res.data.c, res.data.mensaje);
        })
        .catch(error => {
          console.log(error);
        });
      this.close()
    },

    cargaMasiva() {
      router.push('/masivo')
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    activate(id, estado) {
      console.log(id, estado)
    },

    exportExcel(datosXLS) {
      let data = []
      for (let i = 0; i < datosXLS.length; i++) {
        let dtemp = {
          codigo: datosXLS[i].codigo,
          cod_sup: 0,
          correo: datosXLS[i].correo,
          nombres: datosXLS[i].nombres,
          apellidos: datosXLS[i].apellidos,
          fecha_nacimiento: datosXLS[i].fecha_nacimiento,
          fecha_ingreso: datosXLS[i].fecha_ingreso,
          cargo: datosXLS[i].cargo,
          codigo_depto: datosXLS[i].codigo_depto,
          depto: datosXLS[i].depto,
          grupo: datosXLS[i].grupo,
          fono: datosXLS[i].fono,
        }
        data.push(dtemp)
      }
      let dataX = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      const filename = 'empleadosEvaluacion'
      XLSX.utils.book_append_sheet(workbook, dataX, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    generatePrintQr() {
      this.$refs.html2Pdf.generatePdf()
    }

  }
};
</script>

<style>
.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px;
  /* ajusta el tamaño de la fuente según tus necesidades */
  text-transform: uppercase;
}
</style>